import { Box, Typography } from '@mui/material';
import LockPersonIcon from '@mui/icons-material/LockPerson';
import MDButton from '@components/MDButton';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'context/auth-context';

/// Perfil sem tela liberada: sem isto o conteúdo fica vazio e o botão de sair está no menu.
export const NoPermission = () => {
    const { t } = useTranslation();
    const { signOut } = useAuth();

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 1.5,
                minHeight: '70vh',
                px: 3,
                textAlign: 'center',
            }}
        >
            <LockPersonIcon sx={{ fontSize: 48, opacity: 0.5 }} />

            <Typography variant="h5">{t('semPermissao.titulo')}</Typography>

            <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 420 }}>
                {t('semPermissao.ajuda')}
            </Typography>

            <MDButton variant="gradient" color="dark" onClick={signOut} sx={{ mt: 1 }}>
                {t('semPermissao.sair')}
            </MDButton>
        </Box>
    );
};
